import React from 'react';
import { CellField, DataTableColumn } from '@/components/custom/erp';
import { ChiTietKheUocLaiSuat } from '@/types/schemas';

export const getInvoiceCollectionColumns = (
  onCellValueChange: (
    rowUuid: string,
    field: keyof ChiTietKheUocLaiSuat,
    newValue: ChiTietKheUocLaiSuat[keyof ChiTietKheUocLaiSuat]
  ) => void
): DataTableColumn<ChiTietKheUocLaiSuat>[] => [
  {
    field: 'ls',
    headerName: 'Lãi suất (%)',
    width: 150,
    renderCell: params => (
      <CellField
        name='ls'
        type='number'
        placeholder='0'
        value={params.row.ls}
        onValueChange={newValue => onCellValueChange(params.row.uuid, 'ls', newValue)}
      />
    )
  },
  {
    field: 'ngay_hl',
    headerName: 'Hiệu lực từ',
    width: 150,
    renderCell: params => (
      <CellField
        name='ngay_hl'
        type='date'
        value={params.row.ngay_hl}
        onValueChange={newValue => onCellValueChange(params.row.uuid, 'ngay_hl', newValue)}
      />
    )
  },
  {
    field: 'ghi_chu',
    headerName: 'Ghi chú',
    width: 200,
    renderCell: params => (
      <CellField
        name='ghi_chu'
        type='text'
        value={params.row.ghi_chu || ''}
        onValueChange={newValue => onCellValueChange(params.row.uuid, 'ghi_chu', newValue)}
      />
    )
  }
];
